/**
 * CLDR/ICU outdated aliases → current IANA primary identifiers.
 * @see https://github.com/tc39/proposal-canonical-tz
 */
const IANA_PRIMARY_BY_ALIAS = {
  'Asia/Calcutta': 'Asia/Kolkata',
  'Europe/Kiev': 'Europe/Kyiv',
  'Asia/Saigon': 'Asia/Ho_Chi_Minh',
  'Asia/Rangoon': 'Asia/Yangon',
  'Asia/Katmandu': 'Asia/Kathmandu',
  'Africa/Asmera': 'Africa/Asmara',
  'America/Coral_Harbour': 'America/Atikokan',
  'Atlantic/Faeroe': 'Atlantic/Faroe',
  'America/Godthab': 'America/Nuuk',
  'Pacific/Truk': 'Pacific/Chuuk',
  'Pacific/Yap': 'Pacific/Chuuk',
  'Pacific/Enderbury': 'Pacific/Kanton',
  'Pacific/Ponape': 'Pacific/Pohnpei',
  'Asia/Ulan_Bator': 'Asia/Ulaanbaatar',
};

/**
 * Map known CLDR aliases to IANA primary IDs; unknown values pass through.
 */
export function canonicalizeIanaTimezone(tz) {
  if (!tz || typeof tz !== 'string') return tz;
  const trimmed = tz.trim();
  return IANA_PRIMARY_BY_ALIAS[trimmed] || trimmed;
}

/** IANA timezone of the current device (e.g. Asia/Ho_Chi_Minh). */
export function getDeviceTimezone() {
  return canonicalizeIanaTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
}
